import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function WorkspaceBreadcrumb({ items, compactTitle }) {
  const current = items[items.length - 1];
  const parent = items
    .slice(0, -1)
    .filter((item) => item.onClick)
    .pop();

  return (
    <nav className="flex min-w-0 flex-1 items-center font-medium" aria-label="Breadcrumb">
      {parent && (
        <button
          type="button"
          onClick={parent.onClick}
          aria-label={`Back to ${parent.label}`}
          className="mr-2 flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-ink hover:text-ink-secondary focus-visible:outline focus-visible:outline-2 focus-visible:outline-sage lg:hidden"
        >
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" />
        </button>
      )}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <div
            key={`${item.label}-${index}`}
            className={`${isLast ? 'flex' : 'hidden lg:flex'} min-w-0 items-center`}
          >
            {index > 0 && (
              <span className="mx-2 hidden shrink-0 lg:block" aria-hidden="true">
                {'>'}
              </span>
            )}
            {item.onClick && !isLast ? (
              <button
                type="button"
                onClick={item.onClick}
                className="truncate rounded-sm text-ink hover:text-ink-secondary focus:outline-none focus:ring-0 focus-visible:ring-0"
              >
                {item.label}
              </button>
            ) : (
              <div
                className="min-w-0 cursor-default text-ink-muted"
                aria-current={isLast ? 'page' : undefined}
              >
                {isLast && compactTitle && compactTitle !== current?.label ? (
                  <>
                    <span className="block truncate lg:hidden">{compactTitle}</span>
                    <span className="hidden truncate lg:block">{item.label}</span>
                  </>
                ) : (
                  <span className="block truncate">{item.label}</span>
                )}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
}
